module.exports = __webpack_public_path__ + "img/fd4aed6.png";